import { render, staticRenderFns } from "./UserOverview.vue?vue&type=template&id=1abdfeeb&scoped=true&"
import script from "./UserOverview.vue?vue&type=script&lang=js&"
export * from "./UserOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abdfeeb",
  null
  
)

export default component.exports